import React, { useEffect, useState } from "react";
import { ITopMenuItem } from "../../../../types/common.interface";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { t } from "i18next";
import NotFound from "../../../NotFound";
import OnlineDriverTransactionContainer from "./screens/Driver/Container";
import OnlineParentTransactionContainer from "./screens/Parent/Container";
import SubSubTabs from "../../../../components/SubSubTabsList";
import { ONLINE_TRANSACTION } from "../../../../values/subTabs";

type Props = {};

const OnlineTransaction = (props: Props) => {
  const currentMenu = window.location.pathname.split("/")[5];

  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState<ITopMenuItem>(
    ONLINE_TRANSACTION.find(
      (item) => item.pathname === currentMenu
    ) as ITopMenuItem
  );

  function onTabClick(tab: any) {
    navigate(tab.pathname);
    setSelectedTab(tab);
  }

  useEffect(() => {
    setSelectedTab(
      ONLINE_TRANSACTION.find(
        (item) => item.pathname === currentMenu
      ) as ITopMenuItem
    );
  }, [currentMenu]);

  return (
    <section id="setting-screen">
      <SubSubTabs
        tabs={ONLINE_TRANSACTION}
        onClick={onTabClick}
        selected={selectedTab as ITopMenuItem}
      />
      <Routes>
        <Route path='/'       element={<Navigate to={"driver"}           />} />
        <Route path='/driver' element={<OnlineDriverTransactionContainer />} />
        <Route path='/parent' element={<OnlineParentTransactionContainer />} />
        <Route path='/*'      element={<NotFound                         />} />
      </Routes>
    </section>
  );
};

export default OnlineTransaction;
